import { createSlice } from "@reduxjs/toolkit";
import { allNonprofitsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const allNonprofitsSlice = createSlice({
  name: "allNonprofits",
  initialState: data,
  reducers: {
    allNonprofitsSlice(state) {
      state.isLoading = true;
    },
    allNonprofitsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    allNonprofitsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    allNonprofitsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const allNonprofitsHandler = (body:{browse_by:string;page:number;size:number}) => async (dispatch: any) => {
  try {
    dispatch(allNonprofitsAction.allNonprofitsSlice());
    const response: any = await allNonprofitsAPI(body);
    dispatch(allNonprofitsAction.allNonprofitsSliceSuccess(response));
  } catch (e: any) {
    dispatch(allNonprofitsAction.allNonprofitsSliceFailure(e?.response?.data?.message));
    dispatch(allNonprofitsAction.allNonprofitsSliceReset());
  }
};
export default allNonprofitsSlice.reducer;
export const allNonprofitsAction = allNonprofitsSlice.actions;
